import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/views/auth/Login.vue";
import Register from "@/views/auth/Register.vue";
import ForgotPassword from "@/views/auth/ForgotPassword.vue";
import ResetPassword from "@/views/auth/ResetPassword.vue";
import ChangePassword from "@/views/auth/ChangePassword.vue";
import Safety from "@/views/website/Safety.vue";
import TeamMember from "@/views/website/TeamMember.vue";
import Maintenance from "@/views/website/Maintenance.vue";
import RecordsAndTotal from "@/components/Maintenance/RecordsAndTotal.vue";
import ScheduleAndRecurring from "@/components/Maintenance/ScheduleAndRecurring.vue";
import Accidents from '@/components/Safety/Accidents.vue';
import DotInspections from '@/components/Safety/DotInspections.vue';
import Claims from '@/components/Safety/Claims.vue';
import SearchEquipment from "@/views/SearchEquipment.vue";
import Website from "@/views/Website.vue";
import LicenseCart from "@/views/website/LicenseCart.vue";
import ExpiryData from "@/views/website/ExpiryData.vue";
import Dashboard from "@/views/website/Dashboard.vue";
import EquipmentList from "@/views/website/EquipmentList.vue";
import Equipment from "@/views/website/Equipment.vue";
import Team from "@/views/website/Team.vue";
import Customers from "@/views/website/Customers.vue";
import Locations from "@/views/website/Locations.vue";
import CustomerDetails from "@/views/website/CustomerDetails.vue";
import ProfilePage from "@/views/website/ProfilePage.vue";
// import Notifications from "@/views/website/Notifications.vue";
import DriverDetails from "@/views/driver/DriverDetails.vue";
import Documents from "@/views/website/Documents.vue";
import AddAndUpdateDPBVaultDoc from "@/views/website/AddandUpdateDPBVaultDoc";
import DPBVault from "@/views/website/DPBVault";
import DriverSearch from "@/views/website/DriverSearch.vue"
import AllCompanies from "@/views/allCompanies.vue"
import CompanyDetails from "@/views/CompanyDetails.vue"
import Company from "@/views/website/Company.vue"
import DriverDetailsSearch from "@/views/driver/DriverDetailsSearch.vue"
import DriverVehiclesSearch from "@/views/driver/DriverVehiclesSearch.vue"
import DriverTrailersSearch from "@/views/driver/DriverTrailersSearch.vue"
import DriverEquipmentDetails from "@/views/driver/DriverEquipmentDetails.vue"
import Reports from "@/views/website/Reports.vue"
import SubscriptionSuccess from "@/views/SubscriptionSuccess.vue"
import ReportDetails from "@/views/website/reports/ReportDetails.vue"
import FileDrop from "@/views/website/FileDrop.vue"
import AIChat from "@/views/website/AIChat.vue"
import store from "../store";
import { setLocale } from "@/i18n";
import { getGeotabSession } from "@/services/geotab";

// Run the Geotab db-mismatch check only once per app load (not on every nav).
let geotabDbValidated = false;
import HazmatCheck from "@/views/website/HazmatCheck";
import LoadDetails from "@/views/website/HazmatCheck/LoadDetails.vue";
import Recruiting from "@/views/website/Recruiting";
import RecruitingDetails from "@/views/website/Recruiting/RecruitingDetails.vue";
import RecruitingJob from "@/views/website/Recruiting/Jobs.vue";
import Tasks from "@/views/website/Tasks";
import DriverHelp from "@/views/DriverHelp.vue";
import TireTracker from "@/components/Maintenance/TireTracker.vue";
import CreateCompany from "@/views/website/CreateCompany.vue";
import DotInspect from "@/components/Maintenance/DotInspect.vue";
import SSOLogin from "@/views/auth/SSOLogin.vue";
import Citations from "@/components/Safety/Citations.vue";
import Eula from "@/views/Eula.vue";
import Vendors from "@/components/Maintenance/Vendors.vue";
import DVIR from "@/components/Maintenance/DVIR.vue";
import Forms from "@/views/website/Forms"
// import Reports from "@/views/website/reports/Reports.vue";
// import DriverInsuranceReport from "@/views/website/reports/DriverInsuranceReport.vue";
// import EquipmentInsuranceReport from "@/views/website/reports/EquipmentInsuranceReport.vue";
// import DriverBasicReport from "@/views/website/reports/DriverBasicReport.vue";
// import EquipmentBasicReport from "@/views/website/reports/EquipmentBasicReport.vue";
// import ExpiryReport from "@/views/website/reports/ExpiryReport.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Website,
    name: "Website",
    children: [
      {
        path: "",
        name: "Dashboard",
        component: Dashboard,
      },
      {
        path: "/reports",
        name: "Reports",
        component: Reports,
        meta: { 
          requiresPermission: 'Reports'
        },
      },
      {
        path:"/reports/:name",
        name:"ReportDetails",
        component:ReportDetails,
        meta: { 
          requiresPermission: 'Reports'
        },
      },
      {
        path: "/settings",
        name: "Settings",
        component: Company,
      },
      {
        path: "/company",
        name: "Company",
        component: Company,
      },
      {
        path: "/company/motive",
        name: "CompanyMotive",
        component: Company,
      },
       {
        path: "/settings/integrations/samsara",
        name: "SamsaraIntegration",
        component: Company,
      },
      {
        path: "/settings/integrations/motive",
        name: "motiveIntegration",
        component: Company,
      },
      {
        path: "/license-cart",
        name: "LicenseCart",
        component: LicenseCart,
      },
      {
        path: "/expiry-data",
        name: "ExpiryData",
        component: ExpiryData,
      },
      {
        path: "/equipment-list/vehicles",
        name: "Vehicle",
        component: EquipmentList,
        meta: { 
          requiresPermission: 'Equipment'
        },
      },
      {
        path: "/equipment-list/trailers",
        name: "Trailer",
        component: EquipmentList,
        meta: { 
          requiresPermission: 'Equipment'
        },
      },
      {
        path: "/equipment/:id",
        name: "Equipment",
        component: Equipment,
        meta: { 
          requiresPermission: 'Equipment'
        },
      },
      {
        path: "/drivers",
        name: "driver",
        component: Team,
        meta: { 
          requiresPermission: 'Drivers'
        },
      },
      {
        path: "/customers",
        name: "Customers",
        component: Customers,
      },
      {
        path: "/customer/:id",
        name: "CustomerDetails",
        component: CustomerDetails,
      },
      {
        path: "/locations",
        name: "Locations",
        component: Locations,
      },
       {
        path: "/file-drop",
        name: "FileDrop",
        component: FileDrop,
        meta: { 
          excludeRole: 'Owner Operator'
        },
      },
      {
        path: "/tasks",
        name: "Tasks",
        component: Tasks,
         meta: { 
          requiresCompanyFeature: 'show_task'
        },
      },
       {
        path: "/forms",
        name: "Forms",
        component: Forms
      },
      // The builder is the same component as the list: which one shows is read
      // off the route, so a template can be linked to directly.
      {
        path: "/forms/templates/:templateId",
        name: "FormTemplateEditor",
        component: Forms
      },
      {
        path: "/forms/submissions/:submissionId",
        name: "FormFill",
        component: Forms
      },
      {
        path: "/recruiting/leads",
        name: "Recruiting",
        component: Recruiting,
        meta: { 
          requiresPermission: 'Recruiting',
          requiresCompanyFeature: 'show_recruiting'
        },
      },
      {
        path: "/recruiting/jobs",
        name: "RecruitingJob",
        component: RecruitingJob,
        meta: { 
          requiresPermission: 'Recruiting',
          requiresCompanyFeature: 'show_recruiting'
        },
      },
       {
        path: "/recruiting/:id",
        name: "RecruitingDetails",
        component: RecruitingDetails,
        meta: { 
          requiresPermission: 'Recruiting',
          requiresCompanyFeature: 'show_recruiting'
        },
      },
      {
        path: "/hazmat-check",
        name: "HazmatCheck",
        component: HazmatCheck,
        meta: { 
          requiresPermission: 'Hazmat Check',
          requiresCompanyFeature: 'show_hazmat_check'
        },
      },
       {
        path: "/hazmat-check/:id",
        name: "LoadDetails",
        component: LoadDetails,
        meta: { 
          requiresPermission: 'Hazmat Check',
          requiresCompanyFeature: 'show_hazmat_check'
        },
      },
      {
        path: "/ai-chat",
        name: "AIChat",
        component: AIChat,
        meta: { 
          requiresPermission: 'DPB AI Chat',
          requiresCompanyFeature: 'ai_docs'
        },
      },
      {
        path: "/driver/:id",
        name: "TeamMember",
        component: TeamMember,
        meta: { 
          requiresPermission: 'Drivers'
        },
      },
      {
        path: "/maintenance",
        name: "Maintenance",
        component: Maintenance,
        meta: { 
          requiresPermission: 'Maintenance',
          requiresCompanyFeature: 'show_maintenance',
          allowOwnerOperator: true
        },
        children: [
          {
            path: "records",
            name: "Records",
            component: RecordsAndTotal,
            meta: { 
              requiresPermission: 'Maintenance',
              requiresCompanyFeature: 'show_maintenance',
              allowOwnerOperator: true
            },
          },
          {
            path: "schedule",
            name: "Schedule",
            component: ScheduleAndRecurring,
            meta: { 
              requiresPermission: 'Maintenance',
              requiresCompanyFeature: 'show_maintenance',
              excludeRole: 'Owner Operator'
            },
          },
          {
            path: "dvir",
            name: "DVIR",
            component: DVIR,
            meta: { 
              requiresPermission: 'Maintenance',
              requiresCompanyFeature: 'show_maintenance',
              excludeRole: 'Owner Operator'
            },
          },
          // The DVIR screens are the same component: which one shows is read off
          // the route, so every screen has its own shareable url.
          {
            path: "dvir/templates/:templateId",
            name: "DVIRTemplateEditor",
            component: DVIR,
            meta: { 
              requiresPermission: 'Maintenance',
              requiresCompanyFeature: 'show_maintenance',
              excludeRole: 'Owner Operator'
            },
          },
          {
            path: "dvir/inspections/:inspectionId",
            name: "DVIRInspection",
            component: DVIR,
            meta: { 
              requiresPermission: 'Maintenance',
              requiresCompanyFeature: 'show_maintenance',
              excludeRole: 'Owner Operator'
            },
          },
          {
            path: "dvir/inspections/:inspectionId/review",
            name: "DVIRReview",
            component: DVIR,
            meta: { 
              requiresPermission: 'Maintenance',
              requiresCompanyFeature: 'show_maintenance',
              excludeRole: 'Owner Operator'
            },
          },
          {
            path: "tire-tracker",
            name: "TireTracker",
            component: TireTracker,
            meta: { 
              requiresPermission: 'Maintenance',
              requiresCompanyFeature: 'show_maintenance',
              excludeRole: 'Owner Operator'
            },
          },
          {
            path: "dot-inspect",
            name: "DotInspect",
            component: DotInspect,
            meta: { 
              requiresPermission: 'Maintenance',
              requiresCompanyFeature: 'show_maintenance',
              excludeRole: 'Owner Operator'
            },
          },
          {
            path: "vendors",
            name: "Vendors",
            component: Vendors,
            meta: { 
              requiresPermission: 'Maintenance',
              requiresCompanyFeature: 'show_maintenance',
              excludeRole: 'Owner Operator'
            },
          },
        ]
      },
      {
        path: "/safety",
        name: "Safety",
        component: Safety,
        meta: { 
          requiresPermission: 'Safety',
          requiresCompanyFeature: 'show_safety'
        },
        children: [
          {
            path: "dot-inspections",
            name: "DotInspections",
            component: DotInspections,
            meta: { 
              requiresPermission: 'Safety',
              requiresCompanyFeature: 'show_safety'
            },
          },
          {
            path: "accidents",
            name: "Accidents",
            component: Accidents,
            meta: { 
              requiresPermission: 'Safety',
              requiresCompanyFeature: 'show_safety'
            },
          },
          {
            path: "claims",
            name: "Claims",
            component: Claims,
            meta: { 
              requiresPermission: 'Safety',
              requiresCompanyFeature: 'show_safety'
            },
          },
          {
            path: "citations",
            name: "Citations",
            component: Citations,
            meta: { 
              requiresPermission: 'Safety',
              requiresCompanyFeature: 'show_safety'
            },
          },
        ]
      },
      {
        path: "/documents/:type",
        name: "Documents",
        component: Documents,
      },
      {
        path: "/dpb-vault",
        name: "DPBVault",
        component: DPBVault,
         meta: { 
          requiresCompanyFeature: 'show_vault'
        },
      },
      {
        path: "/dpb-vault/add",
        name: "AddDPBVaultDoc",
        component: AddAndUpdateDPBVaultDoc,
         meta: { 
          requiresCompanyFeature: 'show_vault'
        },
      },
      {
        path: "/dpb-vault/update/:id",
        name: "UpdateDPBVaultDoc",
        component: AddAndUpdateDPBVaultDoc,
         meta: { 
          requiresCompanyFeature: 'show_vault'
        },
      }
      // {
      //   path: "/reports",
      //   name: "Reports",
      //   component: Reports,
      // },
      // {
      //   path: "/reports/driver/insurance",
      //   name: "DriverInsuranceReport",
      //   component: DriverInsuranceReport,
      // },
      // {
      //   path: "/reports/equipment/insurance",
      //   name: "EquipmentInsuranceReport",
      //   component: EquipmentInsuranceReport,
      // },
      // {
      //   path: "/reports/driver/basic",
      //   name: "DriverBasicReport",
      //   component: DriverBasicReport,
      // },
      // {
      //   path: "/reports/equipment/basic",
      //   name: "EquipmentBasicReport",
      //   component: EquipmentBasicReport,
      // },
      // {
      //   path: "/reports/expiry",
      //   name: "ExpiryReport",
      //   component: ExpiryReport,
      // },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/sso/:compID",
    name: "SSOLogin",
    component: SSOLogin,
  },
  {
    path: "/subscription-success",
    name: "SubscriptionSuccess",
    component: SubscriptionSuccess,
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
  },
   {
    path: "/driver-help",
    name: "DriverHelp",
    component: DriverHelp,
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
  },
  {
    path: "/password-reset-confirm/:uid/:token",
    name: "ResetPassword",
    component: ResetPassword,
  },
  {
    path: "/app/set-password/:uid/:token",
    name: "ChangePassword",
    component: ChangePassword,
  },
  {
    path: "/search-equipment",
    name: "SearchEquipment",
    component: SearchEquipment,
  },
  {
    path: "/driver-search",
    name: "DriverSearch",
    component: DriverSearch,
  },
  {
    path: "/driver-details",
    name: "DriverDetails",
    component: DriverDetails,
    meta: { roleDriver: true },
  },
  {
    path: "/driver-vehicles-search",
    name: "DriverVehiclesSearch",
    component: DriverVehiclesSearch,
    meta: { roleDriver: true },
  },
  {
    path: "/driver-trailers-search",
    name: "DriverTrailersSearch",
    component: DriverTrailersSearch,
    meta: { roleDriver: true },
  },
  {
    path: "/driver-equipment-details/:id",
    name: "DriverEquipmentDetails",
    component: DriverEquipmentDetails,
    meta: { roleDriver: true },
  },
  {
    path: "/all-companies",
    name: "AllCompanies",
    component: AllCompanies,
  },
  {
    path:"/eula",
    name: "Eula",
    component: Eula
  },
  {
    path: "/create-company",
    name: "CreateCompany",
    component: CreateCompany,
    meta: { requiresCanAddCompany: true },
  },
  {
    path: "/profile-page",
    name: "ProfilePage",
    component: ProfilePage,
  },
  // {
  //   path: "/notifications",
  //   name: "Notifications",
  //   component: Notifications,
  // },
  {
    path: "/driver-details-search",
    name: "DriverDetailsSearch",
    component: DriverDetailsSearch
  },
  {
    path: "/company/:name",
    name: "CompanyDetails",
    component: CompanyDetails
  },
  { path: "*", redirect: "/" },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// Helper function to check permission access
const hasPermission = (permissionName) => {
  const rolePermissions = store.getters.rolePermissions;
  if (!rolePermissions || !rolePermissions[permissionName]) return false;
  
  // For Drivers permission, check if either view permission is allowed
  if (permissionName === 'Drivers') {
    return rolePermissions[permissionName][0]?.allow || rolePermissions[permissionName][1]?.allow;
  }
  
  return rolePermissions[permissionName][0]?.allow;
};

// Helper function to check company feature
const hasCompanyFeature = (featureName) => {
  const company = store.getters.company;
  if (!company || !company[0]) return false;
  return company[0][featureName] === true;
};

// Helper function to get user role
const getUserRole = () => {
  return store.state.user?.user?.team_member?.role;
};

// A deep link (a shared url, a refresh) hits the guard before Website.vue has
// fetched anything, so the permission getters are still empty and every check
// below would fail — sending the user to the dashboard instead of the page they
// asked for. Load what the checks read, once, before judging.
const ensureAccessDataLoaded = async () => {
  if (!localStorage.getItem("token") || !localStorage.getItem("userSelectedCompany")) return;
  const pending = [];
  if (!store.getters.rolePermissions) pending.push(store.dispatch("getRolePermissions"));
  const company = store.getters.company;
  if (!company || !company[0]) pending.push(store.dispatch("getCompany"));
  if (!store.state.user?.user) pending.push(store.dispatch("getUserByID"));
  // A failure here is not the guard's to report: fall through to the checks,
  // which then behave exactly as they did before.
  if (pending.length) await Promise.all(pending.map((request) => request.catch(() => {})));
};

router.beforeEach(async (to, from, next) => {
  window.scrollTo(0, 0);
  if (to.query.lang) setLocale(to.query.lang || localStorage.getItem("appLocale") || 'en');

  const isGeotabAddin = to.query.geotabAddin === "true" || to.query.geotabAddin === true;
  if(isGeotabAddin) store.dispatch('setGeoTabData', isGeotabAddin);

  // When opened inside the Geotab add-in, a token cached from a *different*
  // Geotab database would otherwise route the new user straight to the previous
  // org's data. Once per app load, ask the parent for the live session and, if
  // its database differs from what we logged in with, drop the stale session so
  // the user re-logs in as the active org. Runs before the token is read below.
  if (isGeotabAddin && !geotabDbValidated) {
    geotabDbValidated = true;
    if (localStorage.getItem("token")) {
      try {
        const session = await getGeotabSession(3000);
        if (session && session.database && localStorage.getItem("geoTabDb") !== session.database) {
          localStorage.clear();
        }
      } catch (e) {
        // Bridge unavailable / timed out — leave the existing session untouched.
      }
    }
  }

  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const isEulaNotAccepted = localStorage.getItem("eula_accepted_at") === "false";
  const licenseExpired = localStorage.getItem("licenseExpired") === "true";
  const publicRoutes = [
    "SearchEquipment",
    "CompanyDetails",
    "DriverDetails",
    "DriverSearch",
    "SubscriptionSuccess",
    "DriverHelp"
  ];

  if (isEulaNotAccepted && to.name !== "Eula") {
    next({ name: "Eula" });
  } else if (
    to.name === "Login" ||
    to.name === "SSOLogin" ||
    to.name === "Register" ||
    to.name === "ForgotPassword" ||
    to.name === "ResetPassword" ||
    to.name === "ChangePassword"
  ) {
    if (token) {
      if (role === "Driver") {
        next({ name: "DriverDetails" });
      } else {
        next({ name: "Dashboard" });
      }
    } else {
      next();
    }
  } else if (!token && !publicRoutes.includes(to.name)) {
    next({ name: "Login" });
  } else if (token && publicRoutes.includes(to.name)) {
    if (role === "Driver") {
      next({ name: "DriverDetails" });
    } else {
      next({ name: "Dashboard" });
    }
  } else if (
    token &&
    licenseExpired &&
    to.name !== "Company" &&
    to.name !== "LicenseCart"
  ) {
    next({ name: "Company" });
  } else {
    if (role === "Driver" && !to.meta.roleDriver) {
      next({ name: "DriverDetails" });
    } else if (role !== "Driver" && to.meta.roleDriver && to.name !== "DriverDetails") {
      next({ name: "Dashboard" });
    } else {
      if (to.meta.requiresPermission || to.meta.excludeRole || to.meta.requiresCompanyFeature) {
        await ensureAccessDataLoaded();
      }
      // Check permission-based access
      if (to.meta.requiresPermission) {
        const userRole = getUserRole();
        
        // Check if route excludes certain roles
        if (to.meta.excludeRole && userRole === to.meta.excludeRole) {
          next({ name: "Dashboard" });
          return;
        }
        
        // Allow Owner Operator for maintenance routes if specified
        if (to.meta.allowOwnerOperator && userRole === 'Owner Operator') {
          next();
          return;
        }
        
        // Check company feature requirement
        if (to.meta.requiresCompanyFeature && !hasCompanyFeature(to.meta.requiresCompanyFeature)) {
          next({ name: "Dashboard" });
          return;
        }
        
        // Check permission requirement
        if (!hasPermission(to.meta.requiresPermission)) {
          next({ name: "Dashboard" });
          return;
        }
      }
      
      // Check role exclusion for routes without permission requirements
      if (to.meta.excludeRole) {
        const userRole = getUserRole();
        if (userRole === to.meta.excludeRole) {
          next({ name: "Dashboard" });
          return;
        }
      }
      
      // Check company feature requirement for routes without permission requirements
      if (to.meta.requiresCompanyFeature && !to.meta.requiresPermission) {
        if (!hasCompanyFeature(to.meta.requiresCompanyFeature)) {
          next({ name: "Dashboard" });
          return;
        }
      }
      
      // Check if route requires can_add_company permission
      if (to.meta.requiresCanAddCompany) {
        const user = store.state.user?.user;
        // If user data is loaded, check permission
        if (user && user.team_member) {
          const canAddCompany = user.team_member.can_add_company;
          if (!canAddCompany) {
            next({ name: "AllCompanies" });
            return;
          }
        }
        // If user data not loaded yet, allow navigation (component will handle redirect)
      }
      
      next();
    }
  }
});

export default router;
